module.exports = __webpack_public_path__ + "img/emoActivity.3cbccf64.svg";